import { SaveIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import { cn } from "@/lib/utils";

type SaveFabProps = {
  visible: boolean;
  loading: boolean;
  onClick: () => void;
};

export function SaveFab({ visible, loading, onClick }: SaveFabProps) {
  const { t } = useTranslation();

  return (
    <Button
      type="button"
      onClick={onClick}
      disabled={loading}
      aria-label={t("settings.save")}
      className={cn(
        "fixed right-6 bottom-6 z-40 gap-2 rounded-full bg-emerald-600/90 px-5 py-2.5 text-white shadow-lg transition-all duration-200 hover:bg-emerald-600",
        visible
          ? "translate-y-0 opacity-100"
          : "pointer-events-none translate-y-4 opacity-0",
      )}
    >
      {loading ? <Spinner size="sm" /> : <SaveIcon className="size-4" />}
      <span className="text-[13px] font-medium">
        {loading ? t("settings.skills.detail.saving") : t("settings.save")}
      </span>
    </Button>
  );
}
